

// import VenueSpaceCard from "./VenueSpaceCard";
// import styles from "./VenueSpaces.module.css";

// export default function VenueSpaces({ spaces }) {

//   if (!spaces || spaces.length === 0) {
//     return null;
//   }

//   return (

//     <section className={styles.section}>

//       <h2 className={styles.heading}>
//         Other Event Spaces
//       </h2>

//       <div className={styles.grid}>

//         {spaces.map(space => (

//           <VenueSpaceCard
//             key={space.id}
//             space={space}
//           />

//         ))}

//       </div>

//     </section>

//   );
// }




import VenueSpaceCard from "./VenueSpaceCard";
import VenueSpaceGallery from "./VenueSpaceGallery";
import styles from "./VenueSpaces.module.css";

export default function VenueSpaces({ spaces }) {

  if (!spaces || spaces.length === 0) {
    return null;
  }

  return (

    <section className={styles.section}>

      <h2 className={styles.heading}>
        Other Event Spaces
      </h2>

      <div className={styles.grid}>

        {spaces.map(space => (

          <VenueSpaceCard
            key={space.id}
            space={space}
          />

        ))}

      </div>

      <VenueSpaceGallery spaces={spaces} />

    </section>

  );
}